export default __webpack_public_path__ + "static/media/img_team_member-3.7e63b8b6.png";